import { PageHeader, Screen } from '../../components/chow'
import { useBackNav } from '../choosechow/ChooseChowContext'
import { OpsReceivablesPanel } from './OpsReceivablesPanel'

export const OpsReceivablesPage = () => {
  const back = useBackNav()
  return (
    <Screen
      header={
        <PageHeader
          title="Chef receivables"
          accentDot
          onBack={back}
        />
      }
    >
      <OpsReceivablesPanel />
    </Screen>
  )
}
